import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { getSidebarIcon } from "../utils/sidebarIcons";

export default function SidebarSection({
  title,
  logo,
  active,
  open,
  onToggle,
  children,
}) {
  const [hasLogoError, setHasLogoError] = useState(false);
  const [hasIconError, setHasIconError] = useState(false);

  useEffect(() => {
    setHasLogoError(false);
    setHasIconError(false);
  }, [logo, title]);

  if (!children) return null;
  const icon = getSidebarIcon(title);
  const showLogo = Boolean(logo) && !hasLogoError;
  const showImageIcon =
    !showLogo && icon?.type === "image" && icon?.src && !hasIconError;

  return (
    <section
      className={`new-sidebar-section ${active ? "is-active" : ""} ${
        open ? "is-open" : ""
      }`}
    >
      {title ? (
        <button
          type="button"
          className="new-sidebar-section__title"
          aria-expanded={open}
          onClick={onToggle}
        >
          <span className="new-sidebar-section__icon" aria-hidden="true">
            {showLogo ? (
              <img
                src={logo}
                alt=""
                onError={() => setHasLogoError(true)}
              />
            ) : showImageIcon ? (
              <img
                src={icon.src}
                alt=""
                className={`new-sidebar-section__icon-image ${
                  icon?.name ? `is-${icon.name}` : ""
                }`}
                onError={() => setHasIconError(true)}
              />
            ) : (
              <FontAwesomeIcon icon={icon?.fallback || icon?.icon} />
            )}
          </span>
          <span className="new-sidebar-section__label">{title}</span>
          <span className="new-sidebar-section__chevron" aria-hidden="true">
            <span className="new-sidebar-section__chevron-glyph">
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </span>
        </button>
      ) : null}
      <div className="new-sidebar-section__items">{children}</div>
    </section>
  );
}
